import React, { Component } from 'react';
import { AbstractIcon } from './AbstractIcon';
import { AbstractIconDefaultProps, AbstractIconPropTypes } from './utils';

export class FilterSliderIcon extends Component {
    static defaultProps = AbstractIconDefaultProps;
    static propTypes = AbstractIconPropTypes;

    render() {
        const props = this.props;

        return (
            <AbstractIcon viewBox="0 0 24 25" {...props}>
                <path d="M20 7.94043H9M4 17.9404H15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="6" cy="7.94043" r="2.12132" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                <circle cx="18" cy="17.9404" r="2.12132" stroke="currentColor" strokeWidth="1.5" fill="none"/>
            </AbstractIcon>
        );
    }
}
